import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import type { Artist } from "@libs/wire";
import { timestamps } from "../utils/fields";

// Per-entity-ID durable cache for artist wire shape. Mirrors `cached_songs`
// — see that file for design notes. Single-column PK on artistId.
export const cachedArtists = sqliteTable("cached_artists", {
  ...timestamps,
  artistId: text("artist_id").primaryKey(),
  data: text("data", { mode: "json" }).notNull().$type<Artist>(),
  fetchedAt: integer("fetched_at", { mode: "timestamp_ms" }).notNull(),
});

export type CachedArtistRow = typeof cachedArtists.$inferSelect;
